import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check'

const firebaseConfig = {
  databaseURL: 'https://2022-alkoholrechner.europe-west1.firebasedatabase.app/',
  apiKey: 'AIzaSyDj4VVmQgxfq-59EBB4pZUVBZOOiE_FsPE',
  projectId: 'captchadatabases',
  storageBucket: 'captchadatabases.appspot.com',
  authDomain: 'captchadatabases.firebaseapp.com',
  messagingSenderId: '78621128630',
  appId: '1:78621128630:web:5b1182f6b86e20765df317',
}

if (process.env.NODE_ENV !== 'production') {
  (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}
export const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);

// Initialize AppCheck after the page is loaded
const initAppCheck = () => {
  try {
    console.log('Initializing App Check');
    const appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(
        '6LffZUYqAAAAAM4Fsz5zOSSAqM_6qan1Wy5Oj9Dh'
      ),
      isTokenAutoRefreshEnabled: true,
    });
    console.log('App Check initialized successfully');
    return appCheck;
  } catch (error) {
    console.error('Error initializing App Check:', error);
    return null;
  }
};

// Initialize AppCheck after DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAppCheck);
} else {
  initAppCheck();
}